(function () {
  function selectOneTimePurchase() {
    const selectors = [
      'input[name="selling_plan"][value="once"]',
      'input[type="radio"][value="once"]',
      'input[id*="one-time" i]',
      'label[for*="one-time" i]'
    ];

    for (const selector of selectors) {
      const target = document.querySelector(selector);
      if (!target) continue;

      if (target.tagName === 'LABEL' && target.htmlFor) {
        const input = document.getElementById(target.htmlFor);
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('click', { bubbles: true }));
          return true;
        }
      }

      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      target.dispatchEvent(new Event('click', { bubbles: true }));
      return true;
    }

    const labels = Array.from(document.querySelectorAll('label'));
    const oneTimeLabel = labels.find((label) => /one[-\s]?time/i.test(label.textContent || ''));
    if (oneTimeLabel) {
      oneTimeLabel.click();
      return true;
    }

    return false;
  }

  document.addEventListener('DOMContentLoaded', selectOneTimePurchase);
  document.addEventListener('shopify:section:load', selectOneTimePurchase);
})();
